import chatApi from 'services/chat-api';
import profileApi from 'services/profile-api';

export const api = {
  profile: profileApi,
  chat: chatApi,
};
